// Matches the bank-transactions infinite-query page size in useFetchBankTransactions.
export const BANK_LINE_SUGGESTIONS_PAGE_SIZE = 200

interface BankLineSuggestionPageItem {
  id: string
  match?: {
    isApproved?: boolean
  }
}

export const getBankLineIdPages = (
  bankLines: BankLineSuggestionPageItem[],
  pageSize = BANK_LINE_SUGGESTIONS_PAGE_SIZE,
): string[][] => {
  const pages: string[][] = []

  for (let index = 0; index < bankLines.length; index += pageSize) {
    pages.push(bankLines.slice(index, index + pageSize).map((bankLine) => bankLine.id))
  }

  return pages
}

export const getUnmatchedBankLineIds = (bankLines: BankLineSuggestionPageItem[], bankLineIds: string[]): string[] => {
  const bankLinesById = new Map(bankLines.map((bankLine) => [bankLine.id, bankLine]))

  return bankLineIds.filter((id) => bankLinesById.get(id)?.match?.isApproved !== true)
}
